import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Subscribe.css";
import { creditPricing } from "../../Services/APIrequests";

function Subscribe({ show, handleClose }) {
  const navigate = useNavigate();
  const [razorpayOrderId, setRazorpayOrderId] = useState("");
  const [receiptId, setReceiptId] = useState("");
  const [pricingData, setPricingData] = useState([]);
  const [credits, setCredits] = useState({
    buy2: "",
    buy9: "",
    buy100: "",
    buy1000: "",
  });
  let token = sessionStorage.getItem("token");

  useEffect(() => {
    token = sessionStorage.getItem("token");
  }, []);

  useEffect(() => {
    const fetchCreditPricing = async () => {
      try {
        const response = await creditPricing();
        setPricingData(response.data); 
      } catch (error) {
        console.error("Error fetching credit pricing:", error);
      }
    };
    fetchCreditPricing();
  }, []);

  const handleSubscribe = async (data, razorpay_payment_id, credits) => {
    const paymentCartDetailsApi1 = `http://65.0.57.122:5000/payments/handlePaymentSuccess`;
    let data2 = {
      razorpay_order_id: data.razorpay_orderId,
      razorpay_payment_id: razorpay_payment_id,
      credits: credits,
    };
    const options1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data2),
    };
    const response = await fetch(paymentCartDetailsApi1, options1);
    const data1 = await response.json();

    if (response.status === 200) {
      navigate("/SubscribeSuccessfully");
    } else {
      alert(
        data1.message ||
          "Something went wrong while processing the subscription."
      );
    }
  };

  const handlePayClick = async (pricePerCredit, totalCredits) => {
    try {
      const paymentCartDetailsApi = `http://65.0.57.122:5000/payments/createRazorpayOrder`;

      const totalPrice = pricePerCredit * totalCredits;
    
      const options1 = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          amount: totalPrice,
        }),
      };

      const response = await fetch(paymentCartDetailsApi, options1);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      if (response.ok === true) {
        setRazorpayOrderId(data.data.razorpay_orderId);
        setReceiptId(data.data.receiptId);
        var options = {
     //  key: "rzp_test_8fofedsVTbn7Vv", /*dev*/
        key: "rzp_live_WKIQ0nRZE97CxR", /*prod*/
          amount: totalPrice,
          currency: "INR",
          name: "Kohere",
          description: "Order Payments",
          order_id: data.data.razorpay_orderId,
          handler: function (response) {
            if (response.razorpay_payment_id !== null) {
              handleSubscribe(
                data.data,
                response.razorpay_payment_id,
                totalCredits
              );
            } else {
              alert("Something went wrong, please try again.");
            }
          },
          prefill: {
            name: "kohere",
            email: "kohere@gmail.com",
            // contact: 9010234589,
          },
          notes: {
            address: "",
          },
          theme: {
            color: "#FDFBB9",
          },
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.open();
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while processing the payment.");
    }
  };

  // Conditionally return null for the component rendering
  if (!show) {
    return null;
  }

  return (
    <div>
      <div className="modal">
        <div className="modal-content">
          <div className="modal-heading">
            <h2>Buy Credits</h2>
            <button className="modal-close-button" onClick={handleClose}>
              Close
            </button>
          </div>

          <div className="cards-container">
            {pricingData.map((pricing) => (
              <div className="credit-card" key={pricing.creditPricingId}>
                <h3>
                  Buy {pricing.minCredits} - {pricing.maxCredits || "more"}{" "}
                  credits @ ₹{pricing.pricePerCredit} per company
                </h3>
                <div className="input-container">
                  <label htmlFor={`credits-${pricing.creditPricingId}`}>
                    Total Credits
                  </label>
                  <input
                    type="number"
                    id={`credits-${pricing.creditPricingId}`}
                    value={credits[`buy${pricing.creditPricingId}`] || ""} // Unique state key per pricing ID
                    min={pricing.minCredits}
                    max={pricing.maxCredits || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow clearing the input
                      if (value === "") {
                        setCredits((prev) => ({
                          ...prev,
                          [`buy${pricing.creditPricingId}`]: "",
                        }));
                      } else {
                      
                        const numericValue = parseInt(value, 10);
                        if (
                          numericValue >= pricing.minCredits &&
                          (!pricing.maxCredits ||
                            numericValue <= pricing.maxCredits)
                        ) {
                          setCredits((prev) => ({
                            ...prev,
                            [`buy${pricing.creditPricingId}`]: numericValue, 
                          }));
                        }
                      }
                    }}
                  />
                  <p>
                    (Between {pricing.minCredits} and{" "}
                    {pricing.maxCredits || "more"})
                  </p>
                </div>
                <button
                  className="pay-btn"
                  onClick={() =>
                    handlePayClick(
                      pricing.pricePerCredit,
                      credits[`buy${pricing.creditPricingId}`]
                    )
                  }
                  disabled={
                    credits[`buy${pricing.creditPricingId}`] <
                      pricing.minCredits ||
                    (pricing.maxCredits &&
                      credits[`buy${pricing.creditPricingId}`] >
                        pricing.maxCredits)
                  }
                >
                  Pay{" "}
                  {credits[`buy${pricing.creditPricingId}`] >=
                    pricing.minCredits &&
                  (!pricing.maxCredits ||
                    credits[`buy${pricing.creditPricingId}`] <=
                      pricing.maxCredits)
                    ? `₹${
                        credits[`buy${pricing.creditPricingId}`] *
                        pricing.pricePerCredit
                      }`
                    : ""}
                </button>
              </div>
            ))}
          </div>

          <p>Prices are inclusive of GST.</p>

          <div className="about-credits">
            <h4>About Credits</h4>
            <ul>
              <li>Credits are valid for a year from the date of purchase.</li>
              <li>
                Any credits that are not used within a year from the date of
                purchase will expire.
              </li>
              <li>One credit is required to unlock one company.</li>
              <li>
                Once you unlock a company, you can view the company for a year
                from the date you unlocked it.
              </li>
            </ul>
          </div>

          <div className="contact-info">
            <p>Contact us:</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Subscribe;
